import { z } from "zod/v4";
import { parseByCountry } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";

const parseFormattedNumber = (value: string): number =>
  parseByCountry(value, {
    country: AccountController.accountData?.countryCode
  });

export const itemNameSchema = z
  .string()
  .nonempty("bookingV4.goods.cipl.error.itemDetailMandatory");
export const quantitySchema = z.string().refine(
  (value) => parseFormattedNumber(value) >= 1,
  "bookingV4.goods.cipl.error.quantityMandatory"
);
export const goodsPriceSchema = z.string().refine(
  (value) => parseFormattedNumber(value) >= 1,
  "bookingV4.goods.cipl.error.goodsPriceMandatory"
);
